import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import AnimateHeight from 'react-animate-height';
import get from 'lodash/get';
import Card from 'yoda-core-components/lib/components/Card/Card';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import InStore from 'yoda-core-components/lib/assets/svg/InStore.svg';
import MouseBlack from 'yoda-core-components/lib/assets/svg/MouseBlack.svg';
import IconClose from 'yoda-core-components/lib/assets/svg/IconClose.svg';
import Button from 'yoda-core-components/lib/components/Button';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';

import CouponInfo from './CouponInfo';
import CouponApply from './CouponApply';
import CouponUtilsHelper from '../CouponList/CouponUtilsHelper';
import CouponUrgencyMessage from './CouponUrgencyMessage';
import CouponDetails from './CouponDetails';
import * as styles from './CouponCard.css';
import Config from './CouponConfig';
import { CouponShopNowLabel } from '../../common/Constants';
import { selectFeatureFlags, selectDeviceType, isPreview } from '../../selectors/ContextSelector';
import getPreviewDate from '../../selectors/PreviewDateSelector';
import {
    getDetailedDate,
    getNumberOfHours,
    getHumanizedDate,
    getFormattedPreviewDate,
} from '../../dates/DateFormatter/GetNumberOfDays';
import CouponDetailsModalAction from '../../actions/CouponDetailsModalAction';
import CouponCode from './CouponCode';
import CouponSavings from './CouponSavings';

const cx = classNames.bind(styles);

/* istanbul ignore next */
export class CouponCard extends Component {
    static propTypes = {
        couponData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        couponVariant: PropTypes.oneOf(['Small', 'Default']),
        redeemingChannel: PropTypes.string,
        couponSlot: PropTypes.number,
        bagItemCount: PropTypes.number,
        featureFlags: PropTypes.object,
        displayCouponType: PropTypes.bool,
        deviceType: PropTypes.object,
        actions: PropTypes.objectOf(PropTypes.func),
        couponDetailsModal: PropTypes.bool,
        callbackRef: PropTypes.func,
        drawerContainerRef: PropTypes.object,
        inlineMessaging: PropTypes.bool,
        previewDate: PropTypes.object,
        isPreview: PropTypes.bool,
        isCouponDrawer: PropTypes.bool,
    };

    static defaultProps = {
        couponData: [],
        couponVariant: 'Default',
        onApplyCoupon: null,
        skipOfferMerge: false,
        redeemingChannel: '',
        openLinkInNewTab: '',
        couponSlot: 1,
        bagItemCount: 0,
        featureFlags: {},
        displayCouponType: false,
        deviceType: {},
        actions: {},
        couponDetailsModal: false,
        callbackRef: null,
        drawerContainerRef: null,
        inlineMessaging: false,
        previewDate: null,
        isPreview: false,
        isCouponDrawer: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            couponCardFlipped: false,
            applyCouponRequest: '',
            isAnimation: false,
            detailsWrapper: null,
            showMobileDetailByUser: false,
            isExpired: false,
            expirationDate: '',
            previewExpirationDate: getFormattedPreviewDate(props.isPreview),
            expiredInLessThanDay: false,
            timerLabel: '',
        };
        this.setApplyCouponRequest = this.setApplyCouponRequest.bind(this);
        this.setAnimation = this.setAnimation.bind(this);
        this.couponCardRef = null;
        this.expirationInterval = null;
        this.doMobileShowDetailByUser = this.doMobileShowDetailByUser.bind(this);
    }

    componentDidMount() {
        const { couponData } = this.props;
        const offerEndDate = get(couponData, 'content.offerEndDate', null);
        this.getExpiryDate(offerEndDate, this.state.previewExpirationDate);
        this.cardAnimator = this.couponCardAnimation(this.props.deviceType.isTablet);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.drawerContainerRef !== nextProps.drawerContainerRef) {
            this.drawerContainerRef = nextProps.drawerContainerRef;
        }
        const isRemoveSuccess = get(nextProps, 'couponApplicationState.isRemoveSuccess', false);
        const couponAnimation = get(nextProps, 'couponAnimation', false);
        if (couponAnimation && isRemoveSuccess) {
            CouponUtilsHelper.removePromoCode();
        }
        // toggle coupon details based on redux state
        const closingCurrentModal =
            this.props.couponDetailsModal === this.props.couponSlot &&
            (!nextProps.couponDetailsModal ||
                nextProps.couponDetailsModal !== this.props.couponSlot);
        const openingCurrentModal =
            nextProps.couponDetailsModal === this.props.couponSlot &&
            (!this.props.couponDetailsModal ||
                this.props.couponDetailsModal !== this.props.couponSlot);
        if (closingCurrentModal || openingCurrentModal) {
            const openingOtherModal =
                nextProps.couponDetailsModal &&
                nextProps.couponDetailsModal !== this.props.couponSlot;
            this.toggleCouponDetails(openingOtherModal);
        }
    }

    componentDidUpdate() {
        this.props.deviceType &&
            this.props.deviceType.isMobile &&
            this.state.showMobileDetailByUser &&
            this.toggleCouponDetails();
    }

    componentWillUnmount() {
        clearInterval(this.expirationalInterval);
    }

    getCenterPosition = () => {
        const isTablet = this.props.deviceType && this.props.deviceType.isTablet;
        let modalWidth = isTablet
            ? Math.min(700, window.innerWidth)
            : Math.min(800, window.innerWidth);
        const boundingClientRect = this.couponCardRef.parentNode.getBoundingClientRect();
        const transTop = -(boundingClientRect.top - 136);
        let transLeftBig =
            window.innerWidth / 2 -
            boundingClientRect.left -
            modalWidth / 2 -
            (isTablet ? this.drawerContainerRef.scrollLeft : 0);
        if (isTablet && modalWidth < 700) {
            modalWidth -= 50;
            transLeftBig = -boundingClientRect.left - this.drawerContainerRef.scrollLeft + 25;
        }
        return {
            modalWidth,
            transTop,
            transLeftBig,
        };
    };

    getExpiryDate = (offerEndDate, startDate) => {
        let hoursRemaining = null;
        if (!offerEndDate || (offerEndDate && isNaN(new Date(offerEndDate)))) return null;

        const formattedDate = offerEndDate.match(/^(\d{4})-(\d{2})-(\d{2})/)[0];

        hoursRemaining = getNumberOfHours(offerEndDate, startDate);

        if (hoursRemaining < 24) {
            this.setState({ expiredInLessThanDay: true });

            if (!this.isExpirationalIntervalStarted && hoursRemaining >= 0) {
                this.setExpirationDate(offerEndDate, startDate)();
                this.expirationalInterval = setInterval(
                    this.setExpirationDate(offerEndDate, startDate),
                    1000
                );
            }

            this.isExpirationalIntervalStarted = true;

            return this.setState({ timerLabel: getDetailedDate(offerEndDate, startDate) });
        }

        if (hoursRemaining > 24 && hoursRemaining < 48) {
            return this.setState({ timerLabel: 'Tomorrow' });
        }

        return this.setState({ timerLabel: getHumanizedDate(formattedDate) });
    };

    setApplyCouponRequest(applyCouponRequest) {
        this.setState({ applyCouponRequest });
    }

    setAnimation(running) {
        this.setState({ isAnimation: running });
    }

    setCardExpDate = (expDate) => {
        this.setState({ expirationDate: expDate });
    };

    setExpirationDate = (offerEndDate, startDate) => () => {
        if (this.props.isPreview) {
            return this.setState({
                expirationDate: getDetailedDate(offerEndDate, this.state.previewExpirationDate),
            });
        }

        return this.setState({ expirationDate: getDetailedDate(offerEndDate, startDate) });
    };

    couponCardAnimation(isTablet = false) {
        const cardRef = this.couponCardRef;
        let x = 0;
        let y = 0;
        let widthFinal = 0;
        let reverseMode = false;
        let couponComponentStateUpdate = null;
        let couponDrawerContainer = null;
        const { transformPrefix } = this;
        function transitionendCallBack(e) {
            if (e.propertyName === 'transform') {
                cardRef.style.transition = 'transform 0s';
                cardRef.style.width = `${widthFinal}px`;
                cardRef.style['min-width'] = `${widthFinal}px`;
                cardRef.removeEventListener('transitionend', transitionendCallBack);
                if (reverseMode) {
                    couponComponentStateUpdate(() => {
                        cardRef.style.transition = 'transform 0.4s';
                        cardRef.style.position = 'static';
                        window.requestAnimationFrame(() => {
                            transformPrefix(cardRef, `translate(${0}px, ${0}px) scaleX(${1})`);
                            isTablet && (couponDrawerContainer.style['overflow-x'] = 'scroll');
                        });
                    });
                } else {
                    couponComponentStateUpdate(() => {
                        cardRef.style.transition = 'transform 0.4s';
                        cardRef.style.overflow = 'visible';
                        cardRef.style.position = 'fixed';
                        window.requestAnimationFrame(() => {
                            transformPrefix(cardRef, `translate(${x}px, ${y}px)  scaleX(${1})`);
                        });
                    });
                }
            }
        }

        return {
            start: (endPositionX, endPositionY, modalWidth, setState) => {
                x = endPositionX;
                y = endPositionY;
                widthFinal = modalWidth;
                reverseMode = false;
                couponComponentStateUpdate = setState;
                cardRef.addEventListener('transitionend', transitionendCallBack);
                window.requestAnimationFrame(() => {
                    transformPrefix(cardRef, `translate(${x}px, ${y}px) scaleX(0)`);
                });
            },
            reverse: (cardWidth = 0, containerNode, setState) => {
                widthFinal = parseFloat(cardWidth);
                reverseMode = true;
                couponComponentStateUpdate = setState;
                couponDrawerContainer = containerNode;
                cardRef.addEventListener('transitionend', transitionendCallBack);
                window.requestAnimationFrame(() => {
                    transformPrefix(cardRef, `translate(${x}px, ${y}px) scaleX(0)`);
                });
            },
        };
    }

    /* istanbul ignore next */
    transformPrefix = (element, value) => {
        element.style.msTransform = value; // IE
        element.style.webkitTransform = value; // Chrome and Safari
        element.style.MozTransform = value; // Firefox
        element.style.OTransform = value; // Opera
        element.style.transform = value;
    };

    attachDeviceOrientChange = () => {
        window.addEventListener('resize', this.deviceOrientChangeHandler);
    };

    detachDeviceOrientChange = () => {
        window.removeEventListener('resize', this.deviceOrientChangeHandler);
    };

    deviceOrientChangeHandler = () => {
        const { transTop, transLeftBig, modalWidth } = this.getCenterPosition();
        this.couponCardRef.style.width = `${modalWidth}px`;
        this.couponCardRef.style['min-width'] = `${modalWidth}px`;
        this.transformPrefix(
            this.couponCardRef,
            `translate(${transLeftBig}px, ${transTop}px)  scaleX(${1})`
        );
    };

    toggleCouponDetails = (openingOtherModal) => {
        const node = this.couponCardRef;
        let cardInitialWidth; // Desktop coupon card width
        const isTablet = this.props.deviceType && this.props.deviceType.isTablet;
        if (
            this.props.featureFlags.enableDetailsAnimationNonMobile &&
            !this.props.deviceType.isMobile
        ) {
            /* istanbul ignore next */
            if (!this.state.couponCardFlipped && node instanceof HTMLElement) {
                const { modalWidth, transTop, transLeftBig } = this.getCenterPosition();
                cardInitialWidth = node.style.width;
                this.cardAnimator.start(transLeftBig, transTop, modalWidth, (callBack) => {
                    this.setState(
                        {
                            couponCardFlipped: !this.state.couponCardFlipped,
                        },
                        callBack
                    );
                });
                isTablet && this.attachDeviceOrientChange();
                return;
            }
            /* istanbul ignore next */
            if (this.state.couponCardFlipped && node instanceof HTMLElement) {
                if (this.props.deviceType && this.props.deviceType.isTablet) {
                    cardInitialWidth = 264; // Tablet Coupon card width
                }
                this.cardAnimator.reverse(cardInitialWidth, this.drawerContainerRef, (callBack) => {
                    this.setState(
                        {
                            couponCardFlipped: !this.state.couponCardFlipped,
                        },
                        callBack
                    );
                });
                setTimeout(() => {
                    node.style.zIndex = '3';
                }, 400);
                isTablet && this.detachDeviceOrientChange();
                return;
            }
        }

        if (!this.props.deviceType.isMobile) {
            this.setState({ couponCardFlipped: !this.state.couponCardFlipped });
        } else {
            (this.state.showMobileDetailByUser || !this.state.couponCardFlipped) &&
                this.setState(
                    {
                        couponCardFlipped: !this.state.couponCardFlipped,
                        showMobileDetailByUser: false,
                    },
                    () => {
                        if (this.props.deviceType.isMobile && !openingOtherModal) {
                            node.scrollIntoView();
                        }
                    }
                );
        }
    };

    doMobileShowDetailByUser() {
        this.setState({ showMobileDetailByUser: !this.state.showMobileDetailByUser });
    }

    prepareDetailsWrapper = (defaultRenderer) => {
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        const detailsWrapper = (
            <div
                className={cx(
                    'inlineDetailsWrapper',
                    'couponFlipCardFace',
                    'couponFlipCardFaceBack'
                )}
            >
                <div
                    className={cx('closeIconWrapper')}
                    onClick={() => {
                        if (this.props.deviceType.isMobile) {
                            this.doMobileShowDetailByUser();
                        } else {
                            const isNewDetailsModalOpen =
                                this.props.couponDetailsModal === this.props.couponSlot;
                            this.props.actions.openDetailsModal(
                                isNewDetailsModalOpen ? false : this.props.couponSlot
                            );
                        }
                        // this.props.actions.openDetailsModal(false);
                    }}
                >
                    <Icon iconType="svg" viewBox="0 0 48 48" className={cx('closeIcon')}>
                        <IconClose />
                    </Icon>
                </div>
                {defaultRenderer()}
            </div>
        );
        this.setState({
            detailsWrapper,
        });
    };

    callbackRef = (node) => {
        this.props.callbackRef && this.props.callbackRef(node);
        this.couponCardRef = node;
    };

    expireTheCoupon = () => this.setState({ isExpired: true });

    render() {
        const {
            couponData,
            couponVariant,
            bagItemCount,
            featureFlags,
            deviceType,
            couponSlot,
            inlineMessaging,
            couponDetailsModal,
            isCouponDrawer,
        } = this.props;
        const couponContent = (couponData && couponData.content) || {};
        const { promoCode } = couponContent;

        const { linkText, linkUrl } = couponContent; // Aundy Change
        const { disclaimer } = couponContent;
        const couponClass = '';
        const timerProps = {
            expiryDate: couponContent.offerEndDate,
            liveTextColor: '',
            timerTextColor: '',
            timerZone: 'CST',
        };

        let couponApplyParentClass = cx('couponCodeWrapper');
        if (couponVariant === 'Small') {
            couponApplyParentClass = cx('couponCodeWrapper', 'fullWidth');
        }

        const linkTextShopNow = linkText && linkText.toLowerCase() === CouponShopNowLabel;
        const promoCodeValue = promoCode || 'instore coupons';
        const redeemingChannel = this.props.redeemingChannel || couponContent.redeemingChannel;
        const displayCouponType =
            this.props.displayCouponType || deviceType.isMobile || deviceType.isTablet;
        const useInlineDetails = this.props.displayCouponType; // coupon drawer & mobile coupon page

        let listWrapperClass = 'couponList';
        if (displayCouponType) {
            listWrapperClass = 'couponListNew';
        }

        let couponOnlineHTML = '';
        let couponInstoreHTML = '';
        let getStoreCouponHTML = '';
        let iconTypeHTML = '';

        const onClickCouponCTA = () => {
            window.location = linkUrl;
        };

        // static couponCard
        const isCustomBtn = get(couponData, 'content.isCustomBtn');
        if (isCustomBtn) {
            getStoreCouponHTML = (
                <Button
                    type="button"
                    data-automation-id="at-coupon-goShop"
                    buttonType="Secondary"
                    className={cx('couponShopBtn', 'couponBtnHeight')}
                    size="Md"
                    onClick={onClickCouponCTA}
                >
                    {' '}
                    {couponContent.buttonName}
                </Button>
            );
        }

        if (
            displayCouponType &&
            (redeemingChannel === 'online' || redeemingChannel === 'instore')
        ) {
            const onlineIconStyle = deviceType.isMobile
                ? { width: '24px', height: '24px' }
                : { width: '32px', height: '32px' };
            couponOnlineHTML =
                redeemingChannel === 'online' ? (
                    <div className={cx('couponType')}>
                        <Icon
                            iconType="svg"
                            width={onlineIconStyle.width}
                            height={onlineIconStyle.height}
                            viewBox="0 0 48 48"
                        >
                            <MouseBlack />
                        </Icon>
                        Online
                    </div>
                ) : (
                    ''
                );

            if (redeemingChannel === 'instore') {
                const exists =
                    couponContent.offers.filter((offer) =>
                        Object.prototype.hasOwnProperty.call(offer, 'barCode')
                    ).length > 0;
                // if no barcode and not a department url
                if (!exists && linkUrl && !linkUrl.includes('/d/')) {
                    getStoreCouponHTML = (
                        <div
                            id={`Get Store Coupon|${promoCodeValue}`}
                            className={cx('getStoreButton')}
                        >
                            <Button
                                type="button"
                                data-automation-id="at-coupon-goShop"
                                buttonType="Secondary"
                                className={cx('couponShopBtn')}
                                size="Md"
                                onClick={() => window.open(linkUrl, '_blank')}
                            >
                                Get Store Coupon
                            </Button>
                        </div>
                    );
                }

                // CouponInstoreHtml in here
                couponInstoreHTML = (
                    <div className={cx('couponTypeInstore')}>
                        <Icon iconType="svg" width="24px" height="24px" viewBox="0 2 48 48">
                            <InStore />
                        </Icon>
                        In store
                    </div>
                );

                // if no barcde and is a department url
                if (!exists && (!linkUrl || linkUrl.includes('/d/'))) {
                    const shouldHideInDetailsView =
                        deviceType.isMobile &&
                        this.state.couponCardFlipped &&
                        (redeemingChannel === 'online' || redeemingChannel === 'instore');
                    if (!shouldHideInDetailsView) {
                        getStoreCouponHTML = (
                            <div className={cx('couponTypeInstore')}>
                                <Icon iconType="svg" width="24px" height="24px" viewBox="0 2 48 48">
                                    <InStore />
                                </Icon>
                                <div
                                    className={cx('couponType', 'noCouponNeeded', {
                                        wrap: !couponOnlineHTML,
                                    })}
                                >
                                    In store only. No coupon needed.
                                </div>
                            </div>
                        );
                    }
                    couponInstoreHTML = null;
                }
            } // end of instore
            iconTypeHTML = couponOnlineHTML || couponInstoreHTML;
        }

        let bottomBar = '';
        bottomBar =
            displayCouponType &&
            (couponContent.isCustomBtn ? (
                <div className={cx('staticBottomBar')} />
            ) : (
                <div className={cx('couponDetails')}>
                    <CouponCode
                        {...this.props}
                        expirationDate={this.state.expirationDate}
                        timerLabel={this.state.timerLabel}
                        expiredInLessThanDay={this.state.expiredInLessThanDay}
                        onCouponExpiration={this.expireTheCoupon}
                        featureFlags={this.props.featureFlags}
                        displayCouponType
                        isCouponDrawer={this.props.isCouponDrawer}
                    />
                    <span className={cx('detailsText')}>
                        {/* TODO: #TJ rename this.props.displayCouponType to from */}
                        {!deviceType.isMobile && this.state.couponCardFlipped && (
                            <span className={cx('newCouponDetailsCouponType')}>
                                {couponOnlineHTML}
                            </span>
                        )}
                        <CouponDetails
                            useInlineDetails={useInlineDetails}
                            prepareRenderer={this.prepareDetailsWrapper}
                            detailsPerCodeTheme={useInlineDetails ? cx('detailsPerCodeTheme') : ''}
                            couponDetailsWrapperTheme={
                                useInlineDetails
                                    ? cx('couponDetailsWrapperTheme', {
                                          couponDrawerCardScroll:
                                              deviceType.isMobile && isCouponDrawer,
                                      })
                                    : ''
                            }
                            detailsText={this.state.couponCardFlipped ? 'hide details' : 'details'}
                            disclaimer={disclaimer}
                            promoCode={promoCode}
                            couponSlot={couponSlot}
                            deviceType={this.props.deviceType}
                            doMobileShowDetailByUser={this.doMobileShowDetailByUser}
                            offerDetails={couponContent.offers}
                            isCouponDrawer={this.props.isCouponDrawer}
                            couponDetailsModal={couponDetailsModal}
                        />
                    </span>
                </div>
            ));
        const { isAnimation } = this.state;
        let height = 'auto';
        if (isAnimation && !!this.couponCardRef) {
            height = Math.ceil(this.couponCardRef.getBoundingClientRect().height);
        }
        const innerCard = (
            <div className={cx('rowBlock', listWrapperClass, `${couponClass}`)}>
                {/* Flip card front face start */}
                <div
                    className={cx(
                        'couponInfoLayout',
                        'couponFlipCardFace',
                        'couponFlipCardFaceFront'
                    )}
                    data-automation-id="at-coupon-info-layout"
                >
                    {displayCouponType && deviceType.isMobile ? iconTypeHTML : ''}
                    {
                        /* istanbul ignore next */ couponContent.countdownTimer &&
                        couponContent.offerEndDate ? (
                            <CouponUrgencyMessage
                                customClass={cx('horizontalDesign')}
                                {...timerProps}
                            />
                        ) : (
                            ''
                        )
                    }
                    <CouponInfo
                        {...this.props}
                        openLinkInNewTab={false}
                        redeemingChannel={redeemingChannel}
                        applyCouponRequest={this.state.applyCouponRequest}
                        setApplyCouponRequest={this.setApplyCouponRequest}
                        setAnimation={this.setAnimation}
                        displayCouponType={displayCouponType}
                    />
                </div>
                {/* Flip card front face end */}

                {/* Flip card back face start */}
                {/* eslint-disable jsx-a11y/no-static-element-interactions */}
                {useInlineDetails && this.state.detailsWrapper}
                {/* Flip card back face end */}

                {/* Buttons */}
                <div className={cx('couponCardInfoBlock')}>
                    <div className={cx('couponcardCodeBtnBlock')}>
                        {/* Saving Details Block */}
                        <CouponSavings
                            {...this.props}
                            applyCouponRequest={this.state.applyCouponRequest}
                        />
                        {/* Saving Details Block Ends */}
                        {!displayCouponType ? (
                            <CouponCode
                                {...this.props}
                                timerLabel={this.state.timerLabel}
                                onCouponExpiration={this.expireTheCoupon}
                                expiredInLessThanDay={this.state.expiredInLessThanDay}
                                expirationDate={this.state.expirationDate}
                                featureFlags={this.props.featureFlags}
                                isCouponDrawer={this.props.isCouponDrawer}
                            />
                        ) : (
                            ''
                        )}
                        {/* For > 1025px */}
                        {!displayCouponType ? (
                            <CouponDetails
                                disclaimer={disclaimer}
                                promoCode={promoCode}
                                couponSlot={couponSlot}
                                couponDetailsModal={couponDetailsModal}
                                isCouponDrawer={this.props.isCouponDrawer}
                                offerDetails={couponContent.offers}
                            />
                        ) : (
                            ''
                        )}
                        {/* For > 1025px Ends */}
                    </div>
                    <div className={cx('couponInfoCTABlock')}>
                        <div className={cx('couponApplyLayout')}>
                            {!deviceType.isMobile && couponInstoreHTML}
                            {!this.state.couponCardFlipped && (
                                <div className={couponApplyParentClass}>
                                    <CouponApply
                                        couponSlot={this.props.couponSlot}
                                        {...this.props}
                                        redeemingChannel={redeemingChannel}
                                        displayCouponType={displayCouponType}
                                        setApplyCouponRequest={this.setApplyCouponRequest}
                                        isCouponDrawer={this.props.isCouponDrawer}
                                        enableCouponExposeBarcodes={
                                            featureFlags.enableCouponExposeBarcodes || false
                                        }
                                    />
                                </div>
                            )}
                            {/* {this.renderBarcode(couponData)} */}
                            {!deviceType.isMobile && couponOnlineHTML}
                        </div>
                        {!displayCouponType ? (
                            <div className={cx('couponcardLinkBlock')}>
                                {
                                    /* istanbul ignore next */ !(
                                        featureFlags.Coupon_ShopNowOverApply &&
                                        bagItemCount <= 0 &&
                                        promoCode
                                    ) && linkUrl ? (
                                        <div
                                            id={`${linkText}|${promoCodeValue}`}
                                            className={cx('goShopLinkBlock')}
                                        >
                                            {!linkTextShopNow ? (
                                                <a
                                                    href={linkUrl}
                                                    rel="noopener noreferrer"
                                                    data-automation-id="at-coupon-findStore"
                                                    className={cx('goShopLink')}
                                                >
                                                    {linkText}
                                                </a>
                                            ) : (
                                                <a
                                                    href={linkUrl}
                                                    data-automation-id="at-coupon-goShop"
                                                    className={cx('goShopLink')}
                                                >
                                                    {linkText}
                                                </a>
                                            )}
                                        </div>
                                    ) : (
                                        ''
                                    )
                                }
                                {/* For < 1025px */}
                                <CouponDetails
                                    disclaimer={disclaimer}
                                    promoCode={promoCode}
                                    couponSlot={couponSlot}
                                    couponDetailsModal={couponDetailsModal}
                                    isCouponDrawer={this.props.isCouponDrawer}
                                    offerDetails={couponContent.offers}
                                />
                                {/* For < 1025px Ends */}
                            </div>
                        ) : (
                            ''
                        )}
                        {getStoreCouponHTML}
                    </div>
                </div>

                {/* Bottom bar */}
                {this.props.isCouponDrawer ? (
                    <div className={cx({ expiredCoupon: this.state.isExpired })} />
                ) : null}
                {bottomBar}

                {/* TODO: #TJ replace modalbox with flipcard for animation */}
                <ModalBox
                    showModal={
                        !this.props.featureFlags.enableDetailsAnimationNonMobile &&
                        useInlineDetails &&
                        this.state.couponCardFlipped &&
                        !deviceType.isMobile
                    }
                    renderModalToBody
                    automationId="at-cpn-applied-modal"
                    modalTheme={cx('detailsModalTheme')}
                    modalBlockTheme={cx('modalBlockTheme')}
                    modalContentTheme={cx('detailsModalContentTheme')}
                    modalOverlayTheme={cx('detailsModalOverlayTheme')}
                >
                    <div className={cx({ detailsModal: !deviceType.isMobile })}>
                        {this.state.detailsWrapper}
                        {bottomBar}
                    </div>
                </ModalBox>
            </div>
        );
        return (
            <Card
                callbackRef={this.callbackRef}
                className={cx('couponBlock')}
                cardClass={cx('couponCardWrapper', {
                    withNewCouponDetails: this.state.couponCardFlipped,
                    useInlineDetails,
                    desktopTabletExp: !deviceType.isMobile,
                    isMobile: deviceType.isMobile,
                    isTablet: deviceType.isTablet,
                    hiddenWhenDetailsOpen:
                        !deviceType.isMobile && !featureFlags.enableDetailsAnimationNonMobile,
                })}
            >
                {inlineMessaging && deviceType.isMobile ? (
                    <AnimateHeight
                        className={cx('animateHeight')}
                        duration={100}
                        delay={20}
                        height={height}
                    >
                        {' '}
                        {innerCard}{' '}
                    </AnimateHeight>
                ) : (
                    innerCard
                )}
            </Card>
        );
    }
}

const mapStateToProps = (state) => ({
    featureFlags: selectFeatureFlags(state),
    couponPopupMessages: state.messages && state.messages[Config.COUPON_POPUP_MESSAGES_ID],
    deviceType: selectDeviceType(state),
    previewDate: getPreviewDate(state),
    isPreview: isPreview(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...CouponDetailsModalAction }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CouponCard);
